
namespace GeniuzPOS.PriceChange {

    @Serenity.Decorators.registerClass()
    export class ApprovePriceChangeDialog extends Serenity.EntityDialog<ApprovePriceChangeRow, any> {
        protected getFormKey() { return ApprovePriceChangeForm.formKey; }
        protected getIdProperty() { return ApprovePriceChangeRow.idProperty; }
        protected getLocalTextPrefix() { return ApprovePriceChangeRow.localTextPrefix; }
        protected getNameProperty() { return ApprovePriceChangeRow.nameProperty; }
        protected getService() { return ApprovePriceChangeService.baseUrl; }
        protected getDeletePermission() { return ApprovePriceChangeRow.deletePermission; }
        protected getInsertPermission() { return ApprovePriceChangeRow.insertPermission; }
        protected getUpdatePermission() { return ApprovePriceChangeRow.updatePermission; }

        protected form = new ApprovePriceChangeForm(this.idPrefix);
        public price1: number;
        public price2: number;
        public price3: number;
        public price4: number;
        public price5: number;
        public price6: number;

        public sku: string;
        public ratio: number;
        public qty: number;
        public skuCost: number;

        constructor() {
            super();



        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
                let newSaveApproveBtn: Serenity.ToolButton =
                {
                    title: "อนุมัติ",
                    hint: "Approve and Save [alt+s]",
                    separator: false,
                    cssClass: "button-save-approve",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        var plucode : string = this.form.PluCode.value
                        this.price1 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice1;
                        this.price2 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice2;
                        this.price3 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice3;
                        this.price4 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice4;
                        this.price5 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice5;
                        this.price6 = Product.CsPluRow.getLookup().itemById[plucode].SellUnitPrice6;

                        this.sku = Product.CsPluRow.getLookup().itemById[plucode].SkuCode;
                        this.ratio = Product.CsPluRow.getLookup().itemById[plucode].SellUnitRatio;
                        this.qty =Product.CsSkuRow.getLookup().itemById[ this.sku].QtyOnhand
                        if(this.qty < 1){
                            this.skuCost = this.ratio*(Product.CsSkuRow.getLookup().itemById[ this.sku].StockCostValue / (1))
                        }else{
                            this.skuCost = this.ratio*(Product.CsSkuRow.getLookup().itemById[ this.sku].StockCostValue / (this.qty || 1));
                            }
                        console.log( this.skuCost)

                        Q.confirm(
                            "ราคาเดิม (อ้างอิง ณ ปัจจุบัน) > ราคาที่กำหนดใหม่" + "\r\n" +
                            this.price1 + " > " + this.form.SellUnitPrice1.value + "\r\n" +
                            this.price2 + " > " + this.form.SellUnitPrice2.value + "\r\n" +
                            this.price3 + " > " + this.form.SellUnitPrice3.value + "\r\n" +
                            this.price4 + " > " + this.form.SellUnitPrice4.value + "\r\n" +
                            this.price5 + " > " + this.form.SellUnitPrice5.value + "\r\n" +
                            this.price6 + " > " + this.form.SellUnitPrice6.value + "\r\n" +
                            "(ราคาต้นทุน ณ ปัจจุบัน " + this.skuCost +" )"+ "\r\n" +
                            '    ยืนยันการบันทึก',
                            () => {
                                this.form.ApproveFg.value = "1";
                                this.form.ApproveFg.forceUpdate();
                                this.save((response) => {
                                    this.dialogClose();
                                });
                            });
                    }
                };
                buttons.push(newSaveApproveBtn);
                let newSaveRejectedBtn: Serenity.ToolButton =
                {
                    title: "ไม่อนุมัติ",
                    hint: "Rejected and Save",
                    separator: false,
                    cssClass: "button-save-reject",
                    icon: "fa fa-save",
                    // hotkey: 'alt+s',
                    onClick: (e) => {
                        Q.confirm(
                            "ไม่อนุมัติรายการนี้ " + "\r\n" +
                            ' ยืนยันการบันทึก',
                            () => {
                                this.form.ApproveFg.value = "0";
                                this.form.ApproveFg.forceUpdate();
                                this.save((response) => {
                                    this.dialogClose();
                                });
                            });
                    }
                };
                buttons.push(newSaveRejectedBtn);
            }
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );

            let newSaveRejectedBtn: Serenity.ToolButton =
            {
                title: "ยกเลิกการอนุมัติ",
                hint: "Cancle and Save",
                separator: false,
                cssClass: "button-save-cancle",
                icon: "fa fa-save",
                // hotkey: 'alt+s',
                onClick: (e) => {
                    Q.confirm(
                        "ยกเลิกการอนุมัติรายการนี้ "
                        ,
                        () => {
                            this.form.ApproveFg.value = null;
                            this.form.ApproveFg.forceUpdate();
                            this.save((response) => {
                                this.dialogClose();
                            });
                        });
                }
            }
            buttons.push(newSaveRejectedBtn);

            return buttons;
        }
        protected beforeLoadEntity() {
            let self = this;
            self.toolbar.findButton('save-and-close-button').text('บันทึกรายการ');
            self.toolbar.findButton('delete-button').text('ลบรายการ');

            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".ui-dialog-title").length == 1) {
                            self.element.find(".ui-dialog-title").html("");
                            self.element.find(".ui-dialog-titlebar-text").html("");
                            self.element.find(".ui-dialog-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".ui-dialog-title").length == 1) {
                            self.element.parent().find(".ui-dialog-title").html("");
                            self.element.parent().find(".ui-dialog-titlebar-text").html("");
                            self.element.parent().find(".ui-dialog-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 10);
            })();
        }
        protected afterLoadEntity() {
            super.afterLoadEntity();



            // var date = $.datepicker.formatDate('yymmdd', new Date());
            // var effdate = this.entity.EffectiveDate
            // var a = effdate.split('T')[0];
            // var effectdate = a.split('-')[0] + a.split('-')[1] + a.split('-')[2]
            // //Q.confirm(effectdate + date, () => { });
            // if (effectdate < date) {
                // if (this.entity.ApproveFg == 1) {
                //     this.toolbar.findButton('button-save-approve').hide();
                //     this.toolbar.findButton('button-save-reject').hide();
                //     this.toolbar.findButton('button-save-cancle').hide();
                // }else if (this.entity.ApproveFg == 0) {
                //     this.toolbar.findButton('button-save-cancle').hide();
                //     this.toolbar.findButton('button-save-reject').hide();                  
                // }else{
                //     this.toolbar.findButton('button-save-cancle').hide();     
                //     //ต้องการเพิ่มซ่อน from.ApproveFg
                // }
            // }else{
                if (this.entity.ApproveFg == 1) {
                    if(this.entity.PostFg == 1)
                    { this.toolbar.findButton('button-save-approve').hide();
                      this.toolbar.findButton('button-save-reject').hide();
                      this.toolbar.findButton('button-save-cancle').hide();
                    } else {
                        this.toolbar.findButton('button-save-approve').hide();
                        this.toolbar.findButton('button-save-reject').hide();  
                    }
                }
                else if (this.entity.ApproveFg == 0) { 
                    this.toolbar.findButton('button-save-cancle').hide();
                    this.toolbar.findButton('button-save-reject').hide();
                }
                else{
                    this.toolbar.findButton('button-save-cancle').hide();
                    //ต้องการเพิ่มซ่อน from.ApproveFg
                }

            // }



        }
    }
}